import "./LoginDialog.less"
import { Component } from "react"
import Images from "../../utils/Images";
import { CloseBtn } from "../CloseBtn/CloseBtn";

export default class LoginDialog extends Component<any, any>{
    private static instance:LoginDialog | null = null;

    constructor(props:any){
        super(props);

        this.state = {
            isVisible: false,
            onLoginClick: () => {}
        };
        LoginDialog.instance = this;
    }

    private onLoginClick = (): void => {
        this.setState({isVisible: false});
        this.state.onLoginClick();
    };

    static show = (onLoginClick:() => void): void => {
        LoginDialog.instance!.setState({
            isVisible: true,
            onLoginClick: onLoginClick
        });
    };

    private hide = (): void => {
        this.setState({isVisible: false});
    };

    static hide = (): void => {
        LoginDialog.instance!.hide();
    };

    render(){
        return this.state.isVisible ? <div className="fullscreen-mask fullscreen-dialog-bg-color dialog-overlay-layer">
            <div className="login-dialog-hint-frame">
                <div style={{fontSize:"0.2rem", marginTop:"0.51rem"}}>您还未登录</div>
                <div style={{marginTop:"0.09rem"}}>登录体验更多功能</div>
                <div className="login-dialog-login-btn" onClick={this.onLoginClick}>前往浏览器登录</div>
                <div style={{marginTop:"0.1rem"}}>
                    <span>还没有账号?</span>
                    <span style={{color:"#e88839", marginLeft:"0.1rem", cursor: "pointer"}} onClick={this.onLoginClick}>前往注册</span>
                </div>
                <CloseBtn top="0.1rem" right="0.07rem" onClick={this.hide}></CloseBtn>
            </div>
        </div> : <></>;
    }
}